import React from 'react';
import useSWR from 'swr';
import { useParams } from 'react-router-dom';
import { Form, Button, Card, Spinner, Alert } from 'react-bootstrap';
import espdoppler from '../../../assets/esp-doppler.png';
import styles from '../../../styles.module.css';
import selectEcoById from '../../../services/ecodoppler';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';

export default function EspelhoDoppler() {
  const { id } = useParams();
  const { data: eco, error, isLoading } = useSWR(
    id ? ['eco', id] : null,
    () => selectEcoById(id)
  );

  if (error) {
    return (
      <Alert variant="danger" style={{ marginTop: 10 }}>
        <Alert.Heading>Erro ao carregar laudo de eco!</Alert.Heading>
        <p>Tente novamente.</p>
      </Alert>
    );
  }

  if (isLoading || !eco) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <Spinner animation="border" variant="dark" size="lg" />
      </div>
    );
  }

  return (
    <>
      <style>
        {`@media print {
          #removeMe {
            display: none !important;
          }

          .page {
            page-break-after: always;
          }

          .page:first-of-type {
            margin-top: 0;
          }

          .page:last-of-type {
            margin-bottom: 0;
            page-break-after: auto;
          }
        }`}
      </style>
      <Card>
        <LaudoCardHeader title="ECOCARDIOGRAMA DOPPLER" />
        <Card.Body>
          <Form noValidate className={styles.titleEspelho}>
            <strong className="mr-auto">Laudo: </strong>
            {eco?.CODECO}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Paciente: </strong>
            {`${eco?.CODPAC} - ${eco?.NOMEPAC}`}
            <br></br>
            <strong className="mr-auto">Sexo: </strong>
            {`${eco?.Sexo}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${eco?.dataNascFmt}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${eco?.idadePAC} anos`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Peso: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Altura: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">SC: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">PS: </strong>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">FC: </strong>
            <br></br>
            <strong className="mr-auto">Convênio: </strong>
            {eco?.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {eco?.dataEcoFmt}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Fone: </strong>
            {eco?.CELULARPAC}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br></br>
            {`${eco?.Realizou}`}
            {'/'}
            {`${eco?.Solicitou}`}
            <hr></hr>
            <div className={styles.imageReport}>
              <img
                width="1400px"
                height="1600px"
                loading="lazy"
                src={espdoppler}
                alt="espelho doppler"
              />{' '}
            </div>
            <div id="removeMe" className="text-right">
              <Button variant="outline-primary" onClick={() => window.print()}>
                Imprimir
              </Button>{' '}
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
}
